import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { PersonType, AdditionalInsurers } from '../../../Core/models';
import { InsurersValidationService, SwProcessStateService, CommonService } from '../../../Core/Services';
import { DatePipe } from '@angular/common';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-additional-insurers',
  templateUrl: './additional-insurers.component.html',
  styleUrls: ['./additional-insurers.component.css']
})
export class AdditionalInsurersComponent implements OnInit {

  constructor(private commonService: CommonService,private swProcessStateService: SwProcessStateService,private insurersValidationService: InsurersValidationService) { }
  @Output() onSubmit: EventEmitter<AdditionalInsurers> = new EventEmitter<AdditionalInsurers>();


  insurers: AdditionalInsurers[] = [];
  counter = 2;
  ngOnInit() {
    this.insurersValidationService.addInsurers$.subscribe({
      next: (insurer) => {
        if (this.insurers.length < 8) {
          insurer.number = this.counter.toString();
          this.insurers.push(insurer);
          this.counter++;
          console.log(this.insurers);
        }   
      }
    })
    this.insurersValidationService.removeInsurers$.subscribe({
      next: () => {
        if (this.insurers.length > 0) {
          this.insurers.pop();
          this.counter--;
        }
      }
    })
    this.insurersValidationService.insurersValid$.subscribe({
      next: (error) => {
        this.insurers[error.index].error = error.errorCss
        if (error && error.isInValid) {

          this.insurers[error.index].invalid = error.isInValid
          document.getElementById("txtDate" + (error.index + 2)).classList.add(error.errorCss);
          document.getElementById("Additional" + (error.index + 2)).classList.remove('hidden');
        }
        else {
          this.insurers[error.index].invalid = error.isInValid
          document.getElementById("txtDate" + (error.index + 2)).classList.remove('error');
          document.getElementById("Additional" + (error.index + 2)).classList.add('hidden');
        }
      }
    })
    this.swProcessStateService.isSW$.subscribe(isSw => {
      if (isSw) {
        this.swAddDOB();
      }
    })
  }
  swAddDOB() {
    this.swProcessStateService.swProcessModel$.pipe(take(1)).subscribe(swInput => {
      swInput?.policyHolder?.forEach((x, index) => {
        if (index > 0) {
          let addDOB = new AdditionalInsurers();
          addDOB.date = this.commonService.customDateFormat(x.birthDate, 'dd/MM/yyyy')
          this.insurersValidationService.addSwInsurer(addDOB);
        }   
      })
    })
  }
  submitAnswer(insurer: AdditionalInsurers, index) {
    insurer.index = index;
    this.onSubmit.emit(insurer)
  }

}
